import { useMutation } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import useUserLayoutPreferences from "components/common/EntityDataTable/hooks/useUserLayoutPreferences";
const slicingToJSON = (slicing) => {
  if (slicing === null) {
    return null;
  }
  if (!slicing) {
    return void 0;
  }
  return {
    slice_column: slicing.sliceColumn,
    sort_by: slicing.sortBy,
    order: slicing.order
  };
};
const preferencesToJSON = ({
  attributes,
  sort,
  perPage,
  slicing,
  customPreferences,
  order
}) => ({
  attributes,
  sort: sort ? { order: sort.direction, field: sort.attributeId } : void 0,
  per_page: perPage,
  slicing: slicingToJSON(slicing),
  custom_preferences: customPreferences,
  order
});
const preferencesUrl = (entityTableId, layoutVariant) => {
  const params = layoutVariant ? `?layout_variant=${encodeURIComponent(layoutVariant)}` : "";
  return qualifyUrl(`/entitylists/preferences/${entityTableId}${params}`);
};
const useUpdateUserLayoutPreferences = (entityTableId, layoutVariant) => {
  const { data: userLayoutPreferences = {}, refetch } = useUserLayoutPreferences(entityTableId, layoutVariant);
  const mutationFn = (newPreferences) => fetch(
    "POST",
    preferencesUrl(entityTableId, layoutVariant),
    preferencesToJSON({ ...userLayoutPreferences, ...newPreferences })
  );
  const { mutateAsync } = useMutation({
    mutationFn,
    onError: (error) => {
      UserNotification.error(`Updating table layout preferences failed with error: ${error}`);
    },
    onSuccess: () => refetch()
  });
  return { mutateAsync };
};
export default useUpdateUserLayoutPreferences;
